module.exports = __webpack_public_path__ + "img/order_delivery.ad7bb8de.svg";